
export class M_SERVICE_INFO {
    ID: number;
    ADRES: string;
    SERVIS_TANIMI: string;
    VARSAYILAN: number;
}


// WEBPACK FOOTER //
// ./src/models/M_SERVICE_INFO.ts